import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Settings,
  Image,
  FileText,
  Mail,
  Package,
  Users,
  LogOut,
  ArrowLeft,
  Newspaper,
} from 'lucide-react';
import { useAuth } from './AuthContext';

const baseNav = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/config', label: 'Konfigurasi Site', icon: Settings },
  { to: '/admin/banners', label: 'Banner Hero', icon: Image },
  { to: '/admin/catalog', label: 'Katalog Produk', icon: Package },
  { to: '/admin/articles', label: 'News & Artikel', icon: Newspaper },
  { to: '/admin/about', label: 'Halaman Tentang', icon: FileText },
  { to: '/admin/contact', label: 'Halaman Kontak', icon: Mail },
];
const superNav = { to: '/admin/users', label: 'Kelola User', icon: Users };

export default function AdminLayout() {
  const { admin, ready, logout } = useAuth();
  const loc = useLocation();

  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-white">
        <p className="text-sm text-neutral-400">Memuat...</p>
      </div>
    );

  if (!admin) return <Navigate to="/admin/login" replace state={{ from: loc }} />;

  const nav =
    admin.role === 'super_admin' ? [...baseNav, superNav] : baseNav;

  return (
    <div className="min-h-screen bg-neutral-100 flex" data-testid="admin-shell">
      {/* Sidebar */}
      <aside className="w-64 bg-neutral-950 text-white flex flex-col fixed inset-y-0 left-0">
        <div className="px-6 py-6 border-b border-neutral-800">
          <p className="text-[10px] tracking-[0.25em] text-red-400 font-semibold">
            POWERX
          </p>
          <p className="font-display text-lg font-bold mt-0.5">CMS Admin</p>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.to.split('/').pop() || 'dashboard'}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? 'bg-px-red text-white font-semibold'
                    : 'text-neutral-400 hover:text-white hover:bg-neutral-900'
                }`
              }
            >
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-neutral-800 space-y-1">
          <a
            href="/"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-neutral-400 hover:text-white hover:bg-neutral-900"
          >
            <ArrowLeft className="w-4 h-4" />
            Lihat Website
          </a>
          <button
            onClick={logout}
            data-testid="admin-logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-neutral-400 hover:text-white hover:bg-neutral-900"
          >
            <LogOut className="w-4 h-4" />
            Keluar
          </button>
          <p className="text-xs text-neutral-600 px-3 pt-2 truncate">
            {admin.email}
          </p>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-64 min-h-screen">
        <div className="max-w-5xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
